export default __webpack_public_path__ + "static/media/pgmico(27).bf87c215.png";